var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.086L11.121 9.965L12.535 11.379L10.414 13.5L12.535 15.621L11.121 17.035L9 14.914L6.879 17.035L5.465 15.621L7.586 13.5L5.465 11.379L6.879 9.965L9 12.086Z",
    fill: "#FFBA0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.5H13.414L18 5.086V20.5C18 21.603 17.103 22.5 16 22.5H2C0.897 22.5 0 21.603 0 20.5V2.5C0 1.398 0.897 0.5 2 0.5ZM2 2.5V20.5H16.001L16 6.5H12V2.5H2Z",
    fill: "#FFBA0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.1f4d624292fd8adc549acf2a91aaaee5.svg";
export { ForwardRef as ReactComponent };